import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LegacyClaimSigninComponent } from './components/legacy-claim-signin/legacy-claim-signin.component';
import { LegacyRedirectComponent } from './components/legacy-redirect/legacy-redirect.component';
import { TradePageRedirectComponent } from './components/trade-page-redirect/trade-page-redirect.component';

import { DriveTestComponent } from './drive-test/drive-test.component';


const routes: Routes = [
  // {
  //   path: 'drive-test',
  //   component: DriveTestComponent  
  // } 
  {
    path: 'lead/new/consultation',
    component: LegacyRedirectComponent,
    data: { }
  },
  {
    path: 'node/add/client',
    component: LegacyClaimSigninComponent,
    data: { }
  },
  {
    path: 'trade-account',
    component: TradePageRedirectComponent,
    data: { }
  },
  {
    path: 'test-component',
    component: DriveTestComponent,
    data: { }
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
